import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { VisibilityFilter } from '@usimweb/core/models';

@Component({
    selector: 'usimweb-menu-filter',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './menu-filter.component.html',
    styleUrls: ['./menu-filter.component.scss'],
    standalone: false
})
export class MenuFilterComponent implements OnInit {
  @Output() menuFilterChanged: EventEmitter<VisibilityFilter> = new EventEmitter<VisibilityFilter>();

  public filterVisibility: string = '-';

  constructor() {}

  ngOnInit(): void {}

  public filterChanged(value: VisibilityFilter) {
    this.menuFilterChanged.emit(value);
  }
}
